import React, { Component } from "react";
import { connect } from "react-redux";
import { Grid, Row, Col } from "react-bootstrap";
import SimpleReactValidator from "simple-react-validator";
import Address from "../../ThemeComponents/Address";
import { helperFunctions as HF } from "../../../helper/helperFunctions";
import Contact from "./../../ThemeComponents/Contact";
import User from "./../../ThemeComponents/User";
import { listActions } from "../../../redux/actions/list-actions";
import { userActions } from "../../../redux/actions/user-actions";

// add new tag type form component and files //
import ListForm from "../Lists/ListForm";
import { objectsConstants as OC } from "redux/constant/objects-constant";
import MessageCom from "../../../layouts/Dashboard/Message";

var Modal = require("react-bootstrap-modal");

class SignupCustomer extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            user: {
                contact: {
                    first_name: "",
                    last_name: "",
                    email: "",
                    type_id: "",
                },
                user: {
                    user_name: "",
                    password: "",
                    password_confirmation: "",
                    role_id: "",
                },
                address: {
                    country_id: "",
                    country: "",
                },
                userHasFetched: false,
                brand_requested: "",
                title: '',
            },
            submitted: false,
        };

        this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.getChildState = this.getChildState.bind(this);
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            user: {
                ...this.state.user,
                [name]: value
            }
        });
    }

    componentDidMount() {
        this.props.getListCall('country', "", "", "", "", "country", false);
    }

    getState = state => {
        if (state.tagTypeAddModal !== undefined) {
            this.setState(prevState => ({
                ...prevState.tagTypeAddModal,
                ...state
            }));
        } else {
            this.setState(prevState => ({
                user: {
                    ...prevState.user,
                    ...state
                }
            }));
        }
    };

    openAddNewTagForm = (modelType, displayTitle, listTypeId) => {
        this.getState({
            tagTypeAddModal: true,
            addNewModelType: modelType,
            addNewModelDisplayTitle: displayTitle,
            list_type_id: listTypeId
        });
    };

    handleDropDownAddNewSubmit = (listData, formType) => {
        let list;
        if (this.state.addNewModelType === "region") {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                parent_id: this.state.user.address.country_id,
                parent: this.state.user.address.country,
                component_name: this.state.addNewModelDisplayTitle
            };
        } else {
            list = {
                title: listData.title,
                list_type_id: this.state.list_type_id,
                list_type: this.state.addNewModelType,
                component_name: this.state.addNewModelDisplayTitle
            };
        }

        this.props.storeTagTypeCall(list).then(
            response => {
                if (this.state.addNewModelType === "region") {
                    this.props.refreshRegionsListCall(
                        this.state.user.address.country_id
                    );
                }
                this.props.getListCall(
                    this.state.addNewModelType,
                    "",
                    "",
                    "",
                    "",
                    this.state.addNewModelType,
                    false
                );
                this.setState({
                    ...this.state,
                    tagTypeAddModal: false
                });
            },
            error => {
                return error;
            }
        );
    };

    handleCustomerSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                submitted: true
            });
            const { user } = this.state;
            let obj = {
                ...user,
                customer: {
                    title: user.title,
                    brand: user.brand_requested,
                },
            }
            this.props.signupCustomerCall(obj, user.contact.id).then(
                response => {
                    if (response !== undefined && response.status === "success") {
                        window.location = "/signup-thanks";
                    }
                    //
                },
                error => {
                    return error;
                }
            );
        } else {
            this.setState({ submitted: false });
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleChangeDropdown(selectedOption, info) {
        if (info.name === "state") {
            this.setState({
                customer: {
                    ...this.state.customer,
                    stateId: selectedOption.value
                }
            });
        }
        if (info.name === "country") {
            this.setState(
                {
                    customer: {
                        ...this.state.customer,
                        countryId: selectedOption.value
                    }
                },
                () => {
                    let updatedStates = [];
                    this.props.states.forEach(state => {
                        if (state.countryId === this.state.customer.countryId)
                            updatedStates.push(state);
                    });
                    this.setState({
                        ...this.state.customer,
                        states: updatedStates
                    });
                }
            );
        }
    }
    getChildState(childData) {
        this.setState(
            {
                addressObj: childData
            });
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <MessageCom />
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Grid fluid>
                                    <Row>
                                        <div
                                            className="col-md-8"
                                            style={{
                                                margin: "0 auto",
                                                float: "none"
                                            }}
                                        >
                                            <Col md={12}>
                                                <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                    <div className="fieldWithIcon">
                                                        <h3
                                                            style={{
                                                                fontWeight:
                                                                    "500"
                                                            }}
                                                        >Customer Signup</h3>
                                                    </div>
                                                </div>
                                                <hr />
                                            </Col>

                                            <Col md={12}>
                                                <form
                                                    onSubmit={
                                                        this
                                                            .handleCustomerSubmit
                                                    }
                                                >
                                                    <div>
                                                        <User
                                                            requiredField={{
                                                                user_name:
                                                                    "required",
                                                                password:
                                                                    "required",
                                                                password_confirmation:
                                                                    "required",
                                                                role_id:
                                                                    "required"


                                                            }}
                                                            htmlElement={
                                                                "user"
                                                            }
                                                            hidePasswords='true'
                                                            returnState={
                                                                this
                                                                    .getState
                                                            }
                                                            validatorInstance={
                                                                this
                                                                    .validator
                                                            }
                                                            contactProp={
                                                                this
                                                                    .state
                                                                    .user
                                                            }
                                                        />
                                                    </div>
                                                    <div className="flexElem addCustomer">
                                                        <Contact
                                                            formTypePro="edit"
                                                            contactProp={
                                                                this
                                                                    .state
                                                                    .user
                                                            }
                                                            contactObject={
                                                                this
                                                                    .state
                                                                    .user
                                                            }
                                                            htmlElement={
                                                                "customer"
                                                            }
                                                            shippingAddress={
                                                                false
                                                            }
                                                            requiredField={{
                                                                first_name:
                                                                    "required",
                                                                last_name:
                                                                    "required",
                                                                email: [
                                                                    "email",
                                                                    "required"
                                                                ]
                                                            }}
                                                            getChildState={
                                                                this
                                                                    .getState
                                                            }
                                                            returnState={
                                                                this
                                                                    .getState
                                                            }
                                                            validatorInstance={
                                                                this
                                                                    .validator
                                                            }
                                                        />
                                                    </div>
                                                    <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                        <div className="mt-md fieldWithIcon" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                                            <span className="fieldIcon userIcon"></span>
                                                            <input
                                                                type="text"
                                                                name="brand_requested"
                                                                autoComplete="off"
                                                                className="form-control"
                                                                placeholder="Brand Requested"
                                                                value={this.state.user.brand_requested}
                                                                onChange={this.onChange}
                                                            />
                                                            <span className="customMsg">
                                                                {this.validator.message(
                                                                    "brand_requested",
                                                                    this.state.user.brand_requested,
                                                                    "required"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                        <div className="mt-md fieldWithIcon" style={{ marginLeft: '0px', marginRight: '0px' }}>
                                                            <span className="fieldIcon userIcon"></span>
                                                            <input
                                                                type="text"
                                                                name="title"
                                                                autoComplete="off"
                                                                className="form-control"
                                                                placeholder="Company Name"
                                                                value={this.state.user.title}
                                                                onChange={this.onChange}
                                                            />
                                                            <span className="customMsg">
                                                                {this.validator.message(
                                                                    "Company Name",
                                                                    this.state.user.title,
                                                                    "required"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <Row>
                                                        <Col
                                                            md={12}
                                                        >
                                                            <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                                <div className="fieldWithIcon">
                                                                    <h4 className="mb-xs">
                                                                        Primary
                                                                        Address
                                                                                </h4>
                                                                </div>
                                                            </div>

                                                            <Address
                                                                formTypePro="edit"
                                                                addressPro={
                                                                    this
                                                                        .state
                                                                        .user
                                                                        .address
                                                                }
                                                                addressObject={
                                                                    this
                                                                        .state
                                                                        .user
                                                                        .address
                                                                }
                                                                htmlElement={
                                                                    "customer"
                                                                }
                                                                shippingAddress={
                                                                    false
                                                                }
                                                                options={{
                                                                    countries: this
                                                                        .props
                                                                        .countries
                                                                }}
                                                                requiredField={{
                                                                    country_id:
                                                                        "required",
                                                                    line1:
                                                                        "required",
                                                                    city:
                                                                        "required",
                                                                    region_id:
                                                                        "required",
                                                                    zip_post_code: ""
                                                                        ? [
                                                                            "integer",
                                                                            "required"
                                                                        ]
                                                                        : [
                                                                            "integer"
                                                                        ]
                                                                }}
                                                                countries={
                                                                    this
                                                                        .props
                                                                        .countries
                                                                }
                                                                getChildState={
                                                                    this
                                                                        .getChildState
                                                                }
                                                                returnState={
                                                                    this
                                                                        .getState
                                                                }
                                                                validatorInstance={
                                                                    this
                                                                        .validator
                                                                }
                                                                openAddNewTagForm={
                                                                    this
                                                                        .openAddNewTagForm
                                                                }
                                                                showTagTypeAddModal={
                                                                    this
                                                                        .props
                                                                        .showTagTypeAddModal
                                                                }
                                                                refreshRegionsTime={
                                                                    this
                                                                        .state
                                                                        .refreshRegionsTime
                                                                }
                                                                hideAddNewStateModal={true}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <div className="col-md-12 text-center mt-xlg">
                                                        <input
                                                            type="submit"
                                                            value="Signup"
                                                            className="customBtn btnBlue"
                                                        />
                                                    </div>
                                                </form>
                                            </Col>
                                        </div>
                                    </Row>
                                </Grid>
                            </Col>
                        </Row>
                    </Grid>
                </div>

                {/*Add Modal Start*/}
                {this.props.TagLayoutData !== null && (
                    <Modal
                        show={this.state.tagTypeAddModal}
                        onHide={HF.closeModal.bind(this, "tagTypeAddModal")}
                        aria-labelledby="ModalHeader"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title
                                id="ModalHeader"
                                className="headerTitle text-capitalize"
                            >
                                Add {this.state.addNewModelDisplayTitle}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-md-8 col-md-offset-2">
                                    <ListForm
                                        closeModel={HF.closeModal.bind(
                                            this,
                                            "tagTypeAddModal"
                                        )}
                                        formTypePro="add"
                                        listPro={{ list: OC.list }}
                                        handleListSubmit={
                                            this.handleDropDownAddNewSubmit
                                        }
                                        name={this.props.title}
                                        componentPro={"List"}
                                        parent_id={this.state.tagTypeParentId}
                                    />
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )}
                {/*Add Modal End*/}
            </React.Fragment>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        getListCall: (
            id,
            page,
            filter,
            sort,
            pageSize,
            component_name,
            pagination
        ) => {
            dispatch(
                listActions.getList(
                    id,
                    page,
                    filter,
                    sort,
                    pageSize,
                    component_name,
                    pagination
                )
            );
        },
        getUserItemCall: id => {
            return dispatch(userActions.getUser(id));
        },
        storeTagTypeCall: listData => {
            return dispatch(listActions.storeList(listData));
        },
        refreshRegionsListCall: id => {
            return dispatch(listActions.getListItem(id));
        },
        signupCustomerCall: (data, id, model = {}) => {
            return dispatch(userActions.signupCustomer(data, id, model));
        }
    };
};

function mapStateToProps(state) {
    const { country, address } = state.listReducer;
    const { editUser } = state.userReducer;
    return {
        countries: country,
        address,
        editUser
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupCustomer);


// WEBPACK FOOTER //
// ./src/components/Admin/Users/SignupCustomer.jsx